export default "__VITE_ASSET__Cc9xxkoX__"